import React from 'react';
import { IconProps } from '.';

const SvgBelow = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M10.75 6v7.25H18v1.5H9.25V6h1.5Z' />
    </svg>
  );
};

export default SvgBelow;
